export default __webpack_public_path__ + "static/dustin-bitmoji-74984315cddb0e6bc32371929964e0d9.png";